import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { translate, downloadFile, showMessageToastCustom, formatDate } from '../../../../utils/util';
import InventoryService from '../../../../services/InventoryService';
import ListDivergingItemsGeneral from './ListDivergingItemsGeneral';
import { ENUMS } from '../../../../utils/constants';
import { ButtonIcon, ListPagination } from '../../../../components/UI/ComponentsUI';
import { onValueChange } from '../../../../utils/handleChangeHooks';
import { useEffect } from 'react';
import { Select } from '../../../../components/UI/ComponentsUI';
import ButtonUI from '../../../../components/UI/ButtonUI';
import InputUI from '../../../../components/UI/InputUI';
import Breadcrumbs from '../../../../components/UI/Breadcrumbs';

const DivergingItemsGeneral = (props) => {
    const [filter, setfilter] = useState({
        inventoryId: props.filter.inventoryId,
        divergent: true,
        adjusted: false,
        balanceId: null,
        zoneCode: '',
        lotOriginId: ENUMS.eInventoryOriginCount.Undefined.value
    });
    const [currentPage, setCurrentPage] = useState(0);
    const [lotItemsReading, setLotItems] = useState([]);

    useEffect(() => {
        if (props.lotItemsReading?.items?.length > 0) {
            if (lotItemsReading.length > 0 && currentPage === 0) {
                setLotItems(props.lotItemsReading.items);
            } else {
                setLotItems((prevState) => ([...prevState, ...props.lotItemsReading.items]));
            }
        } else {
            setLotItems([]);
        }
        // eslint-disable-next-line
    }, [props.lotItemsReading?.items]);

    useEffect(() => {
        applyFilter();
        // eslint-disable-next-line
    }, [currentPage]);

    const onChange = (event) => {
        onValueChange(event, filter, setfilter);
    };

    const downloadItens = () => {
        props.getLotItemsFile(filter, (response) => {
            if (response) {
                downloadFile(response.data, response.fileName, response.type, true);
            } else {
                showMessageToastCustom(translate('warning', 'general'), translate('Nenhum item encontrado'), 3000, 'mdi mdi-alert-circle-outline red-text');
            }
        });
    };

    const formatDescription = (item) => {
        return `${formatDate(item.referenceDate)} - V${item.version}`;
    }

    const applyFilter = () => {
        props.getLotItems(filter, {
            PageSize: ENUMS.ePagination.PageSize.value,
            PageIndex: currentPage
        });
    };

    return (
        <div>
            <Breadcrumbs id="divergingItems" title={{ icon: "mdi mdi-clipboard-check-outline", label: translate('inventory', 'inventory') }}
                subtitles={[{ icon: "mdi mdi-file-document-outline", label: translate('general.menu.divergingItems', 'inventory') }]} />

            <ButtonIcon icon="mdi mdi-download-outline" onClick={downloadItens} />
            <div className="container" style={{ marginTop: '40px', }}>
                <div className="row">
                    <div className="col s4" style={{ marginTop: '15px', }}>
                        <InputUI
                            id="zoneCode"
                            name="zoneCode"
                            placeholder={translate('general.zone', 'inventory')}
                            type="number"
                            onChange={onChange}
                            maxLength="20"
                        />
                    </div>
                    {props.balanceData && props.balanceData.length > 0 &&
                        <div className="no-padding col s6">
                            <Select
                                id="balanceId"
                                name="balanceId"
                                placeHolder={'Data Almox'}
                                data={props.balanceData ? props.balanceData.map((i) => { return { id: i.balanceId, text: formatDescription(i) }; }) : []}
                                change={onChange}
                                defaultValue={filter?.balanceId}
                            />
                        </div>
                    }
                </div>
                <div className="row" style={{ marginBottom: '0px' }}>
                    <ButtonUI full="true" onClick={() => applyFilter()} text={translate('apply', 'general')} />
                </div>
            </div>
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div id="listLotItems">
                    <ListPagination
                        page={props.lotItemsReading?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        data={
                            lotItemsReading.map((item) => {
                                return <ListDivergingItemsGeneral itemProps={item} refresh={applyFilter} />
                            })
                        }
                    />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.inventoryReducer.filter,
        inventory: state.inventoryReducer.inventory,
        balanceData: state.inventoryReducer.balanceData,
        lotItemsReading: state.inventoryReducer.lotItemsReading
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getLotItemsFile: (filter, callback) => {
            dispatch(InventoryService.getBytesItemsReading(filter, callback));
        },
        getLotItems: (vision, filter, pagination) => {
            dispatch(InventoryService.getLotItemsReading(vision, filter, pagination));
        },

    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DivergingItemsGeneral)));
